@if(indicatorService.loading$ | async){
<div class="spinner-container">
  <!-- <div class="spinner"></div> -->
  <img src="../../assets/layout/images/phidelity_logo.png" alt="Loading..." class="loading-image" />
  <!-- <img src="../../assets/layout/images/phi_easfalistiki.png" alt="Loading..." class="loading-image" /> -->

</div>
}
